import Enum from "../../../../../enums/Enum";

const ClaimStatus = new Enum({
    PENDING: {name: "Pending"},
    AUDITED: {name: "Audited"},
    VERIFIED: {name: "Verified"},
    SUBMITTED: {name: "Submitted"},
    REJECTED: {name: "Rejected"},
    APPROVED: {name: "Approved"}
});

ClaimStatus.remittanceStatus = [ClaimStatus.APPROVED, ClaimStatus.REJECTED];

// Statuses selectable when manually adjusting a claim; APPROVED/REJECTED are remittance-owned
ClaimStatus.manualStatuses = [
    ClaimStatus.PENDING, ClaimStatus.AUDITED, ClaimStatus.VERIFIED, ClaimStatus.SUBMITTED
];

export default ClaimStatus;
